var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoExams"},[_c('div',[_c('h2',[_vm._v("Você vai realizar procedimento(s) de:")]),_vm._l((_vm.listUniqueExamTypes),function(examType){return _c('ul',{key:examType},[_c('li',{staticClass:"infoExams-item"},[_vm._v(_vm._s(examType))])])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }